// Custom Accordion Component - Intended to use with disconnected components where normal accordion setup won't work

function defineAccordions() {
  const allHeaders = document.querySelectorAll("[data-custom-accordion]");

  allHeaders.forEach(header=>{
    const content = document.querySelector(`[data-custom-accordion-content="${header.getAttribute("data-custom-accordion")}"]`);
    if (!content) return;
    header.addEventListener("click", () => {
      if (!content.hasAttribute("open")) {
        header.setAttribute("open", "true");
        content.setAttribute("open", "true");

        if (header.hasAttribute("data-accordion-open-text")) header.textContent = header.getAttribute("data-accordion-open-text");
        if (header.querySelector("[data-accordion-open-text]")) Array.from(header.querySelectorAll("[data-accordion-open-text]")).forEach(textBox=>textBox.textContent = textBox.getAttribute("data-accordion-open-text"));
      } else {
        header.removeAttribute("open");
        content.removeAttribute("open");

        if (header.hasAttribute("data-accordion-close-text")) header.textContent = header.getAttribute("data-accordion-close-text");
        if (header.querySelector("[data-accordion-close-text]")) Array.from(header.querySelectorAll("[data-accordion-close-text]")).forEach(textBox=>textBox.textContent = textBox.getAttribute("data-accordion-close-text"));
      }
    })
  })
}
defineAccordions();